import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsField from "../../components/fields/NsField";

export default function ModificaStrutturaClasseMacrocategoriaView({
                                                                      show,
                                                                      setShow,
                                                                      modalMsg,
                                                                      translate,
                                                                      formikRef,
                                                                      SignupSchema,
                                                                      aggiungiStrutturaClasseMacrocategoria,
                                                                      optionsClassi,
                                                                      bottoniSx,
                                                                      bottoniDx,
                                                                      initialValuesForm,
                                                                  }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-tag'}
                title={'Inserisci Struttura Classe Macrocategoria'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={initialValuesForm}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={aggiungiStrutturaClasseMacrocategoria}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"id_classe_macrocategoria_madre"}
                                    label={"Classe Macrocategoria Madre*:"}
                                    as={"select"}
                                    options={(optionsClassi ? optionsClassi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_macrocategoria,
                                        };
                                    }) : [])}
                                    placeholder={translate("Seleziona una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"id_classe_macrocategoria"}
                                    label={"Classe Macrocategoria Figlia*:"}
                                    as={"select"}
                                    options={(optionsClassi ? optionsClassi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_macrocategoria,
                                        };
                                    }) : [])}
                                    placeholder={translate("Seleziona una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}